import CssBaseline from '@mui/material/CssBaseline';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { store } from './redux/store';
import { router } from './router/router';

function App() {
	return (
		<Provider store={store}>
			<CssBaseline />
			<RouterProvider router={router} />
		</Provider>
	);
}

export default App;
